module.exports = __webpack_public_path__ + "images/external_images/svg/mockups/horizontal-tablet-mockup-1.svg";